import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { PolicyErrorSvgComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/policy-error-svg/policy-error-svg.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AddPolicyDataService } from './../../../../../../_services/signup-process-service/add-policy-data.service';
import { ActivatedRoute , RouterModule } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, PolicyErrorSvgComponent, MapfreButtonComponent],
  selector: 'app-add-policy-conflicts',
  templateUrl: './add-policy-conflicts.component.html',
})
export class AddPolicyConflictsComponent implements OnInit {
  policyId: string;
  email: string;
  isAcmic: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private addPolicyDataService: AddPolicyDataService,
    private acmicService: AcmicService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.policyId = params['id'];
    });

    this.email = this.addPolicyDataService.maskEmail();
    this.isAcmic = this.acmicService.isACMIC();
  }
}
